{
  "columns": {
    "status": "Status",
    "resource_type": "Resource type",
    "actions_conflict": "Actions for conflict",
    "message": "Message"
  },
  "statuses": {
    "new": "New",
    "success": "Success",
    "skipped": "Skipped",
    "conflict": "Conflict",
    "error": "Error"
  },
  "controls": {
    "nextStage": "Next stage",
    "prevStage": "Previous stage",
    "reset": "Reset"
  },
  "states": {
    "idle": "Waiting for input",
    "success": "Success",
    "warning": "Warning",
    "loading": "Loading...",
    "error": "Error",
    "importedWithErrors": "Imported with errors",
    "userActionRequired": "User action required"
  },
  "stages": {
    "analyze": "Analyze",
    "result": "Result"
  },
  "messages": {
    "common_action": "Choose common action",
    "placeholder": "New name",
    "conflict_actions": {
      "replace": "Resource updated successfully",
      "rename": "Resource renamed successfully",
      "success": "Resource created successfully",
      "error": "An unknown error occurred",
      "skipped": "Import skipped by user",
      "canceled": "Import canceled"
    },
    "options": {
      "skip": "Skip action",
      "replace": "Replace existing",
      "rename": "Rename"
    }
  }
}